import React, { useState, useRef, useEffect } from 'react';
import { LoginSocialFacebook } from 'reactjs-social-login';
import Styles from '../Socials.module.scss';
import { error as errorToast } from 'helpers/toaster.js';
import { postInstagramIntegration } from 'services/integrationService';
import { useSelector } from 'react-redux';
import { getRequest } from 'helpers/axios';
import ErrorModal from 'Components/Modal/CampaignErrorModal/CampaignErrorModal';
import UpgradeModal from 'Containers/Modal/UpgradeModal/UpgradeModal';
import { FaInstagram } from 'react-icons/fa';

const InstagramLoginForm = ({ onLoginSuccess }) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorDetails, setErrorDetails] = useState({ message: '', link: '' });
  const [showInstagramLogin, setShowInstagramLogin] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { current_subscription: currentSubscription } =
    user?.subscriptions ?? {};

  const loginRef = useRef(null);

  // Auto-click the LoginSocialFacebook trigger once limits are verified
  useEffect(() => {
    if (showInstagramLogin && loginRef.current) {
      loginRef.current.click();
    }
  }, [showInstagramLogin]);

  const handleInstagramClick = async () => {
    try {
      const limitResponse = await getRequest(
        'check_limits?type=platform_integration',
      );

      if (!limitResponse.data.success) {
        if (currentSubscription?.plan_name === 'Basic Plan') {
          setShowUpgradeModal(true);
        } else {
          setErrorDetails({
            message:
              limitResponse.data.message ||
              'You have reached your platform integration limit',
            link: limitResponse.data.link || '',
          });
          setErrorModal(true);
        }
      } else {
        setShowInstagramLogin(true);
      }
    } catch (error) {
      setErrorDetails({
        message:
          error.response?.data?.error ||
          'You have reached your platform integration limit',
        link: 'https://appsumo.com/products/vocable-ai/?p=1',
      });

      if (currentSubscription?.plan_name === 'Basic Plan') {
        setShowUpgradeModal(true);
      } else {
        setErrorModal(true);
      }
    }
  };

  const handleInstagramLogin = async ({ data }) => {
    try {
      const accessToken = data?.accessToken;

      if (!accessToken || !data?.userID) {
        console.error('Instagram login: No valid token received');
        setShowInstagramLogin(false);
        return;
      }

      await postInstagramIntegration({
        access_token: accessToken,
      });
      onLoginSuccess();
      setShowInstagramLogin(false);
    } catch (error) {
      const message =
        error.response?.data?.error?.message ||
        error.response?.data?.error ||
        error.response?.data?.message;
      errorToast(message || 'Failed to connect Instagram');
      console.error('Instagram Login Error:', error);
      setShowInstagramLogin(false);
    }
  };

  return (
    <div>
      {showInstagramLogin ? (
        <LoginSocialFacebook
          appId={process.env.REACT_APP_FACEBOOK_OAUTH_APP_ID || '516068428115571'}
          scope="pages_manage_posts,pages_show_list,pages_read_engagement,business_management,instagram_basic,instagram_content_publish,instagram_manage_comments,instagram_manage_insights"
          isOnlyGetToken={true}
          onResolve={handleInstagramLogin}
          onReject={(error) => {
            console.error('Instagram login rejected:', error);
            setShowInstagramLogin(false);
          }}
        >
          <div ref={loginRef} className={`${Styles.IntegrationBtn} rounded-4`}>
            <FaInstagram style={{ width: '2rem', height: '2rem' }} color="#E1306C" />
            <p>Instagram</p>
          </div>
        </LoginSocialFacebook>
      ) : (
        <div
          className={`${Styles.IntegrationBtn} rounded-4`}
          onClick={handleInstagramClick}
        >
          <FaInstagram style={{ width: '2rem', height: '2rem' }} color="#E1306C" />
          <p>Instagram</p>
        </div>
      )}

      {showUpgradeModal && (
        <UpgradeModal
          show={showUpgradeModal}
          onHide={() => setShowUpgradeModal(false)}
        />
      )}

      {errorModal && (
        <ErrorModal
          show={errorModal}
          onHide={() => setErrorModal(false)}
          errorMessage={errorDetails.message}
          errorLink={errorDetails.link}
        />
      )}
    </div>
  );
};

export default InstagramLoginForm;
